"use client"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Loader2 } from "lucide-react"
import { useTranslations } from "next-intl"



interface DeleteCallDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isDeleting: boolean
}

export function DeleteCallDialog({
  open,
  onOpenChange,
  onConfirm,
  isDeleting,
}: DeleteCallDialogProps) {

  const tUi = useTranslations("Calls.CallsDeleteCallDialog")
  const tCommonUi = useTranslations("Common")

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle><span key={tUi("deleteCallRecord")}>{tUi("deleteCallRecord")}</span></AlertDialogTitle>
          <AlertDialogDescription>
            <span key={tUi("areYouSureYouWantToDeleteThis")}>{tUi("areYouSureYouWantToDeleteThis")}</span></AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}><span key={tCommonUi("cancel")}>{tCommonUi("cancel")}</span></AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-red-600 hover:bg-red-700"
          >
            {isDeleting ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                <span key={tUi("deleting")}>{tUi("deleting")}</span></>
            ) : (
              tUi("delete")
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
